import React, { createContext, useReducer } from 'react';
import { RecordRTCPromisesHandler } from 'recordrtc';

interface CameraStateContext {
  microphoneEnabled: boolean;
  fullscreenEnabled: boolean;
  pipEnabled: boolean;
  soundEnabled: boolean;
  recording: {
    recordingEnabled: boolean;
    startTime: number | null;
    recorder: RecordRTCPromisesHandler | null;
  };
}

export type RecordingContext = CameraStateContext['recording'];

type CameraStateActions =
  | {
      type: 'microphone' | 'fullscreen' | 'pip' | 'sound';
      newValue: boolean;
    }
  | {
      type: 'recording';
      payload: CameraStateContext['recording'];
    };

export const CameraStateContext = createContext<CameraStateContext>({} as CameraStateContext);

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const CameraStateDispatchContext = createContext<React.Dispatch<CameraStateActions>>(() => {});

interface CameraStateProviderProps {
  initState: CameraStateContext;
  children: React.ReactNode;
}

const reducer = (state: CameraStateContext, action: CameraStateActions) => {
  switch (action.type) {
    case 'microphone':
      return { ...state, microphoneEnabled: action.newValue };
    case 'fullscreen':
      return { ...state, fullscreenEnabled: action.newValue };
    case 'pip':
      return { ...state, pipEnabled: action.newValue };
    case 'sound':
      return { ...state, soundEnabled: action.newValue };
    case 'recording':
      return {
        ...state,
        recording: { ...state.recording, ...action.payload },
      };
    default:
      return state;
  }
};

export const CameraStateProvider = ({ initState, children }: CameraStateProviderProps) => {
  const [state, dispatch] = useReducer(reducer, initState);

  return (
    <CameraStateContext.Provider value={state}>
      <CameraStateDispatchContext.Provider value={dispatch}>{children}</CameraStateDispatchContext.Provider>
    </CameraStateContext.Provider>
  );
};
